import { ConnectionNames } from "../Contracts";
import { QueryBuilder } from "./Helpers";
import { BaseRESTConnection } from "../Common";
export class BetsReportingConnection extends BaseRESTConnection {
    constructor(meta) {
        super(ConnectionNames.betsReporting, meta);
    }
    getSettledBets(q) {
        return this.applyQuery(QueryBuilder.getSettledBets(q));
    }
}
//# sourceMappingURL=BetsReportingConnection.js.map